import { post, get, put } from 'axios';
import { URL_CONSTANTS } from '../../../api-data-mapping/url-constants';

// Function to get basket by ticker
const getBasketByTicker = (tokenUser, ticker) => {
  const url = URL_CONSTANTS.GET_BASKET_BY_TICKER.replace('{{BASKET}}', ticker);

  return get(url, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

// Function to consult if basket exist

const consultExistBasket = (tokenUser, ticker) => {
  const url = URL_CONSTANTS.CONSULT_EXIST_BASKET.replace('{{BASKET}}', ticker);

  return get(url, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const createBasket = (tokenUser, data) => {
  return post(URL_CONSTANTS.SUBMITLIVEBASKET, data, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const uploadBacktest = (tokenUser, data, ticker) => {
  return post(URL_CONSTANTS.UPLOAD_BACKTEST_BASKET.replace('{{BASKET}}', ticker), data, {
    headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${tokenUser}` },
  });
};

const uploadFileSettings = (tokenUser, file) => {
  return post(URL_CONSTANTS.UPLOADFILELIVEBASKET, file, {
    headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${tokenUser}` },
  });
};

const coverageRequest = (tokenUser, data) => {
  return post(URL_CONSTANTS.COVERAGE_REQUEST_URL, data, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const updateBasket = (tokenUser, data) => {
  return post(URL_CONSTANTS.UPDATELIVEBASKET, data, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const createTax = (tokenUser, data) => {
  return post(URL_CONSTANTS.CREATE_WITHHOLDING_TAX, data, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const updateTax = (tokenUser, data) => {
  return put(URL_CONSTANTS.CREATE_WITHHOLDING_TAX, data, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

export const uploadFileMultiple = (token, file) => {
  return post(URL_CONSTANTS.UPLOAD_BACKTEST_BASKET_MULTIPLE, file, {
    headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` },
  });
};

const updateBulkBasket = (tokenUser, data) => {
  return post(URL_CONSTANTS.UPDATEBULKBASKET, data, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const createBulkBasket = (tokenUser, data) => {
  return post(URL_CONSTANTS.CREATEBULKBASKET, data, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const getBasket = tokenUser => {
  return get(URL_CONSTANTS.GETLIVEBASKET, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const getBasketById = (tokenUser, basket) => {
  return get(`${URL_CONSTANTS.GETLIVEBASKET}/${basket}`, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const downloadTemplate = (tokenUser, body) => {
  return post(`${URL_CONSTANTS.DOWNLOAD_TEMPLATE_BASKET}`, body, {
    headers: { Authorization: `Bearer ${tokenUser}` },
    responseType: 'blob',
  });
};

const getWithholdingTaxTemplates = user => {
  return get(URL_CONSTANTS.WITHHOLDING_TAX, {
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

const recalculateCoverage = (tokenUser, data) => {
  return post(URL_CONSTANTS.COVERAGE_REQUEST_UPDATE_URL, data, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

const getCalculationZones = tokenUser => {
  return get(URL_CONSTANTS.CALCULATION_ZONES_URL, {
    headers: { Authorization: `Bearer ${tokenUser}` },
  });
};

export {
  getBasketByTicker,
  consultExistBasket,
  createBasket,
  uploadFileSettings,
  coverageRequest,
  updateBasket,
  createTax,
  updateTax,
  uploadBacktest,
  updateBulkBasket,
  createBulkBasket,
  getBasket,
  getBasketById,
  downloadTemplate,
  getWithholdingTaxTemplates,
  recalculateCoverage,
  getCalculationZones,
};
